/**
 * Renders the sign-in screen and the related handling for logins triggered through Moodle.
 * Concretely, if a login via Moodle is detected, a custom firebase auth will be used based
 * on the Firebase token generated on the backend.
 */

import React, {useContext} from "react";
import {Redirect} from 'react-router-dom';

import {FirebaseAuthContext} from 'components/commons/firebase/FirebaseAuthProvider';
import useMoodleSignIn from 'components/commons/signin/moodleSignIn/useMoodleSignIn';
import {useIntl} from "react-intl";
import LoadingProgressIndication from "../../elements/progress/loading/LoadingProgressIndication";

export default function SignInSectionMoodle() {
    const {signedInUser} = useContext(FirebaseAuthContext)

    // Retrieve get parameter from the Moodle request including the generated Firebase custom token
    const searchParams = new URLSearchParams(window.location.search)

    /*
   Fetch Moodle account data from the provided GET parameters.
   This is used after the successful custom token authentication to enrich the created auth entry.
    */
    const firebaseCustomToken = searchParams.get('firebaseCustomToken')
    const ltiKey = searchParams.get('ltik')
    const moodleEmail = searchParams.get('moodleEmail')
    const moodleName = searchParams.get('moodleName')
    const moodleReturnUrl = searchParams.get('moodleReturnUrl')

    /*
    Callback handler triggered if the user signs-in through Moodle - initiated by Moodle through our custom backend
    Important: the user might already be authenticate by either Google or Moodle
               but as the new request comes from Moodle now, we sign-in the user by custom token (i.e. Moodle).
     */
    const {moodleSignInInProgress} = useMoodleSignIn(firebaseCustomToken, ltiKey, moodleEmail, moodleName, moodleReturnUrl)

    // Internationalization for simple strings
    const intl = useIntl();


    // This constellation is obviously an error caused by the user (i.e. manipulated the URL)
    // Redirect to the "Google" login page (there is no other possibility, as the user is not authenticated)
    if (!firebaseCustomToken) {
        return <Redirect to={"/"}/>;
    }

    /*
    If the user is already authenticated, a redirect to the app entry point must occur.
    This entry point forwards the user based on the respective user roles.
     */
    if (signedInUser && !moodleSignInInProgress) {
        return <Redirect to={"/authorizedGate"}/>;
    }

    return (
        <LoadingProgressIndication
            text={intl.formatMessage({
                id: 'app.signIn.moodle.redirection.loading',
                defaultMessage: 'Handling Moodle Redirection...'
            })}/>
    );
}
